<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        :max-date="data.form.dataAtual"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="6" >
                    <rkm-form-input-autocomplete
                        :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                        :repository="repositories.paciente"
                        v-model="paciente"
                        :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                        label="Paciente"
                        uppercase
                        @select="setListagem()"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.dataNascimento"
                        :max-date="data.form.dataAtual"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                        number
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Número do agendamento"
                        v-model="model.agendamentoNumero"
                        number
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row class="mt-3" v-if="itemsNotSave">
            <rkm-col>
                <rkm-button
                    @click="handleListPrint()"
                    color="primary"
                    class="mb-2"
                >
                    Imprimir listagem
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave || items"
            :fields="fields"
            hide-filters
            sort-by="pacienteNome"
        >

            <template v-slot:cell(pacienteNome)="{ item }">
                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(usuarioId)="{ item }">
                <rkm-form-select
                    :label="false"
                    :options="usuario"
                    textField="usuarioOcupacao"
                    v-model="item.usuarioId"
                    valueField="id"
                    show-default-option
                    class="pt-0 mb-0"
                    @change="handleOcupacao(item)"
                />
            </template>
            <template v-slot:cell(status)="{ item }">
                <rkm-form-select
                    :label="false"
                    :options="data.form.status"
                    textField="descricao"
                    v-model="item.statusId"
                    valueField="id"
                    show-default-option
                    class="pt-0 mb-0"
                />
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    small
                    title="Imprimir exame"
                    @click="handlePrint(item)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, printExameLaboratorial } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "pacienteNome",
                    label: "Nome",
                    sortable: true
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "nomeMae",
                    label: "Nome da mãe",
                    sortable: true
                },
                {
                    key: "pacienteProntuario",
                    label: "Prontuário",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "dataColeta",
                    label: "Data da coleta",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "agendamentoNumero",
                    label: "Agendamento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "exameGrupoNome",
                    label: "Exame / Grupo",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
    },
    created() {

        this.repositories = {
            impressaoExame: this.getConectaSusRepository('exameLaboratorial.impressaoExame'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                dataNascimento: null,
                prontuario: null,
                pacienteId: null,
                agendamentoNumero: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            itemsNotSave: null,
            saveAgendamento: {
                agendamentos: [],
            },
            paciente: null,
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            enums: {
                statusAgendamento,
                preferenciaNome
            },
        }
    },
    mixins: [repository, error, object, formats, data, printExameLaboratorial, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo
        },
        search() {

            this.setLoading()

            this.repositories.impressaoExame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.dataNascimento) {

                params.dataNascimento = moment(this.model.dataNascimento).format('YYYY-MM-DD')
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.paciente = null
            this.model.dataNascimento = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.itemsNotSave = null

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleListPrint() {

            this.setLoading()

            this.repositories.impressao.exameList(this.getSearchParams())
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        setListagem() {

            this.itemsNotSave = null
        },
        handlePrint(item) {

            this.setLoading()

            this.repositories.impressao.exame({
                agendamento_id: item.agendamentoId,
                pertence_grupo: item.pertenceGrupo,
                exame_grupo_id: item.exameGrupoId,
                mapa_agrupado: item.mapaAgrupado ?? null,
                assinatura_profissional_id: item.assinaturaProfissionalId ?? null,
            })
            .then(response => {

                const content = new Blob([response.data], {type: response.headers['content-type']})
                const url = URL.createObjectURL(content)
                const link = document.createElement('a')

                link.href = url
                link.target = '_blank'
                link.click()
                link.remove()
            })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'model.periodo.start'() {

            this.setListagem()
        },
        'model.periodo.end'() {

            this.setListagem()
        }
    }
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
</style>